var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"big-download-btn",attrs:{"id":"download"},on:{"click":function($event){return _vm.download()}}},[_c('img',{staticClass:"dowanlod-img",attrs:{"src":require("@/assets/gb/downlaod.png"),"alt":"dowanlod"}}),_vm._v(" "),_c('div',{staticClass:"dowanlod-name"},[_vm._v("\n\t\tDownload\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }